import { render, staticRenderFns } from "./FilterUserBlock.vue?vue&type=template&id=39577171"
import script from "./FilterUserBlock.vue?vue&type=script&lang=js"
export * from "./FilterUserBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39577171')) {
      api.createRecord('39577171', component.options)
    } else {
      api.reload('39577171', component.options)
    }
    module.hot.accept("./FilterUserBlock.vue?vue&type=template&id=39577171", function () {
      api.rerender('39577171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Segment/Components/FilterUserBlock.vue"
export default component.exports